import {
    DayPicker,
    type DayPickerProps,
    type Formatters,
} from 'react-day-picker';
import {
    calendarClassNames,
    calendarComponents,
    selectedDayClass,
} from './calendarStyles';

interface DateCalendarProps {
    disabled?: DayPickerProps['disabled'];
    startMonth?: DayPickerProps['startMonth'];
    endMonth?: DayPickerProps['endMonth'];
    selected: Date | undefined;
    onSelect: (date: Date | undefined) => void;
    month: Date;
    onMonthChange: DayPickerProps['onMonthChange'];
    formatWeekdayName: Formatters['formatWeekdayName'];
}

export function DateCalendar({
    selected,
    onSelect,
    month,
    onMonthChange,
    disabled,
    startMonth,
    endMonth,
    formatWeekdayName,
}: DateCalendarProps) {
    return (
        <DayPicker
            mode="single"
            showOutsideDays
            disabled={disabled}
            startMonth={startMonth}
            endMonth={endMonth}
            selected={selected}
            onSelect={onSelect}
            month={month}
            onMonthChange={onMonthChange}
            components={calendarComponents}
            formatters={{
                formatWeekdayName,
            }}
            classNames={{
                ...calendarClassNames,
                selected: selectedDayClass,
            }}
        />
    );
}
